import type { ReactNode } from 'react';
import styles from './moduleGrid.module.css';

/**
 * The module page grid: 12 columns, `space/20` gutters; children default to
 * span 6 and take `spanClass(span)` for anything else. Ported from the
 * prototype's `moduleGrid.module.css` `.grid`.
 */
export function ModuleGrid({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={[styles.grid, className].filter(Boolean).join(' ')}>{children}</div>;
}
